'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/SquaresFour.es.js";
const r = a.forwardRef((e$1, a$1) => /* @__PURE__ */ a.createElement(p, { ref: a$1, ...e$1, weights: e }));
r.displayName = "SquaresFourIcon";
const n = r;
export {
  n as SquaresFour,
  r as SquaresFourIcon
};
